import IcFavorite from './IcFavorite'

export default IcFavorite
